export default __webpack_public_path__ + "static/media/bh-ico.068619b4.svg";